import React from 'react';

import { Stack } from '@mui/material';

import { DashboardFilterCVAdminCustomButton } from './DashboardFilterCVAdminCustomButton';
import { DashboardFilterCVAdminDateButton } from './DashboardFilterCVAdminDateButton';
import { useAnchor } from './hooks';

export const DashboardFilterCVAdmin: React.FC<{
  hideDateButton?: boolean;
  hideCustomButton?: boolean;
  disableDateButton?: boolean;
  disableCustomButton?: boolean;
}> = ({ hideDateButton, hideCustomButton, disableDateButton, disableCustomButton }) => {
  const { anchorRef, getAnchorRef } = useAnchor();

  return (
    <Stack flexDirection="row" gap={1.5} ref={anchorRef}>
      {!hideDateButton && (
        <DashboardFilterCVAdminDateButton
          getAnchorRef={getAnchorRef}
          disabled={disableDateButton}
        />
      )}
      {!hideCustomButton && (
        <DashboardFilterCVAdminCustomButton
          getAnchorRef={getAnchorRef}
          disabled={disableCustomButton}
        />
      )}
    </Stack>
  );
};
